import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { signOut } from 'aws-amplify/auth';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { useUser } from "../../../UserContext";
import { MenuIcon } from '../../../Constants/Icons';
import { menuNavbarContainer, menuNavbarX, menuNavbarButtonContainer } from '../../../Constants/Styles';

const styles = {
    container: 'w-full h-[55px] xs:h-[60px] xl:h-[60px] flex items-center flex-row justify-between shadow-md bg-[#26051C] md:px-8 xl:px-12 transition-all duration-300',
    logoButton: 'w-48 mx-4 xs:w-60 xl:w-72 xs:mx-6',
    mobileMenuButton: 'block sm:hidden mx-4 xs:mx-6',
    mobileMenuContainer: 'fixed top-0 right-0 bg-charmPurple border border-gray-300 p-4 flex flex-col w-full h-full transition-transform duration-300',
    closeButton: 'text-white self-end text-lg xl:text-xl font-semibold py-2',
    menuButtonContainer: 'w-full flex items-center justify-center',
    menuButton: 'w-fit text-white text-lg xl:text-xl font-semibold py-2 hover:border-b-4 border-link',
    dropdownContainer: 'fixed top-0 right-0 bg-white border border-gray-300 p-4 flex flex-col w-[25rem] h-40 z-50',
    vendorInfo: 'font-bold',
    accountButtonContainer: 'mt-6 flex flex-row justify-start',
    accountButton: 'text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full mr-5',
    signOutButton: 'text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full',
    desktopMenuContainer: 'hidden sm:flex flex-row mx-4 xs:mx-6 gap-4 xs:gap-12 justify-between items-center',
    desktopMenuButton: 'w-fit text-white text-lg xl:text-xl font-semibold py-2 border-b-4 border-transparent hover:border-link transition-all duration-300',
    bellIcon: 'h-[20px] xs:h-[26px] transform hover:scale-125 transition-transform duration-100',
    profileIcon: 'h-[28px] xs:h-[36px] transform hover:scale-125 transition-transform duration-100'
};

const VendorNav = ({ navbarColor }) => {
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
    const { isSignedIn, setIsSignedIn } = useUser();
    const [vendorEmail, setVendorEmail] = useState('');
    const [vendorId, setVendorId] = useState('');
    const [vendorName, setVendorName] = useState('');
    const [isVisible, setIsVisible] = useState(false);
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    useEffect(() => {
        const checkUser = async () => {
            try {
                const userAttributes = await fetchUserAttributes();
                setVendorName(userAttributes['custom:vendorName']);
                setVendorId(userAttributes['custom:vendorId']);
                setVendorEmail(userAttributes['email']);
            } catch (error) {
            }
        };
        checkUser();
    }, []);

    const handleSignOut = async () => {
        try {
            await signOut();
            setIsSignedIn(false);
            navigate('/vendors');
        } catch (error) {
        }
    };

    const toggleVisibility = () => setIsVisible(!isVisible);
    const toggleMenuVisibility = () => setIsMenuVisible(!isMenuVisible);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('.sign-out-button')) {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        if (isVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isVisible]);

    const handleLogo = () => {
        navigate("/");
    };


    return (
        <div className="w-full h-[60px] flex flex-row justify-between items-center px-basePx xs:px-xsPx 1.5xl:py-[18px] 1.5xl:px-[104px]" style={{ backgroundColor: navbarColor, transition: 'background-color 0.4s ease' }}>
            <button onClick={handleLogo} className="w-[248px] min-w-[248px] xl:w-[280px]">
                <img
                    src={'https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealthhub_logo_wht_ylw.png'}
                    alt="Logo"
                    className="w-full"
                />
            </button>
            {
                isSignedIn ?
                    <div>
                        <button className="lg:hidden" onClick={toggleMenuVisibility}>
                            <MenuIcon />
                        </button>

                        {isMenuVisible && (
                            <div className="lg:hidden px-[32px] fixed top-0 right-0 bg-charmPurple flex flex-col w-full h-screen" style={{ zIndex: 50 }}>
                                <button className="pr-[12px] pt-[12px]  text-white self-end  text-[20px] font-extrabold" onClick={toggleMenuVisibility}>
                                    X
                                </button>
                                <div className="mt-[20px] w-full flex flex-col items-center gap-[12px] ">
                                    <button className="h-fit w-fit text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={() => navigate("/vendors/profile/dashboard")}>Dashboard</button>

                                    <button className="h-fit w-fit text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={toggleVisibility}>My Info</button>
                                </div>
                            </div>
                        )}

                        <div className="hidden lg:flex h-[60px] flex-row items-center gap-[56px] ">
                            <button className="h-full text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={() => navigate("/vendors/profile/dashboard")}>Dashboard
                            </button>

                            <button className="h-full text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={toggleVisibility}>My Info</button>
                        </div>

                        {isVisible && (
                            <div ref={dropdownRef} className={styles.dropdownContainer}>
                                <div className={styles.vendorInfo}>{vendorName}</div>
                                <div>{vendorEmail}</div>
                                <div className="absolute top-2 right-4">Vendor ID: #{vendorId}</div>
                                <div className={styles.accountButtonContainer}>
                                    <button onClick={() => navigate("/vendors/profile/self")} className={styles.accountButton}>My Account</button>
                                    <button className={styles.signOutButton} onClick={handleSignOut}>Sign Out</button>
                                </div>
                            </div>
                        )}
                    </div>
                    :
                    <div>
                        <button className="lg:hidden" onClick={toggleMenuVisibility}>
                            <MenuIcon />
                        </button>

                        {isMenuVisible && (
                            <div className="lg:hidden px-[32px] fixed top-0 right-0 bg-charmPurple flex flex-col w-full h-screen" style={{ zIndex: 50 }}>
                                <button className="pr-[12px] pt-[12px]  text-white self-end  text-[20px] font-extrabold" onClick={toggleMenuVisibility}>
                                    X
                                </button>

                                <div className="mt-[20px] w-full flex flex-col items-center gap-[12px] ">
                                    <button className="h-fit w-fit text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={() => navigate("/vendors/signup")}>Register as a Vendor</button>

                                    <button className="h-fit w-fit text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={() => navigate("/vendors/login")}>Vendor Login</button>
                                </div>
                            </div>
                        )}

                        <div className="hidden lg:flex h-[60px] flex-row items-center gap-[56px] ">
                            <button className="h-full text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={() => navigate("/vendors/signup")}>Register as a Vendor</button>

                            <button className="h-full text-white text-[18px]  font-proximanova border-b-[2px] border-transparent hover:border-link transition-all duration-500" onClick={() => navigate("/vendors/login")}>Vendor Login</button>
                        </div>
                    </div>
            }
        </div >
    );
};

export default VendorNav;